export default __webpack_public_path__ + "static/media/1670.b62b8b5a.png";